import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { PEDIDOS_API_RESOURCE } from '../../consts';
import { PedidoItem } from '../pedido-item';
import { PedidoItemDescontoMaximoExcedidoResponse } from '../adapters';

@Injectable({
    providedIn: 'root'
})
export class PedidoItemHttpService {
    private pathApi: string;

    constructor(private configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${PEDIDOS_API_RESOURCE}`;
    }

    /** Pesquisa todos os itens do pedido informado */
    search(idPedido: number): Observable<PedidoItem[]> {
        return this.customHttp.get<PedidoItem[]>(`${this.pathApi}/${idPedido}/itens`);
    }

    /** Pesquisa os itens de um pedido que possui os percentuais de descontos excedidos, ou seja, acima do limite permitido **/
    searchDescontosMaximosExcedidos(idPedido: number): Observable<PedidoItemDescontoMaximoExcedidoResponse[]> {
        return this.customHttp.get<PedidoItemDescontoMaximoExcedidoResponse[]>(`${this.pathApi}/${idPedido}/itens/descontos-maximos-excedidos`);
    }
}
